// see details here https://date-fns.org/v2.15.0/docs/format
export const dateFormat = 'd MMM yyyy';
export const timeFormat = 'HH:mm';
export const dateTimeFormat = `${dateFormat} ${timeFormat}`;
